import { useForm } from 'react-hook-form'
import { useModal } from '@/hooks/useModal'
import { zodResolver } from '@hookform/resolvers/zod'
import { ModalType } from '@/constants/common.contant'
import { forgotPasswordSchema, ForgotPasswordRequest } from '@/utils/schemas'
import { SubmitButton } from '../Buttons'
import { Input } from '../Input'

const ForgotPasswordForm = () => {
  const { closeModal } = useModal(ModalType.Auth)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordRequest>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: '',
    },
  })

  const onSubmit = async () => {
    try {
      // Call API for forgot password logic
      closeModal()
    } catch (error) {
      throw Error('Error requesting password reset:' + error)
    }
  }

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <h2 className="text-2xl font-bold text-center text-primary uppercase mb-4">Quên Mật Khẩu</h2>
      <Input
        label="Email của bạn"
        name="email"
        type="email"
        register={register}
        error={errors.email}
        placeholder="Nhập email để đặt lại mật khẩu"
      />
      <div className="flex items-center justify-around gap-6 mt-4">
        <button
          onClick={closeModal}
          type="button"
          className="w-[80%] bg-white text-black border uppercase py-2 rounded"
          aria-label="close button"
        >
          Đóng
        </button>
        <SubmitButton isLoading={false}>Gửi</SubmitButton>
      </div>
    </form>
  )
}

export default ForgotPasswordForm
